import { BarChart3 } from 'lucide-react';

export default function MonitoringPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center gap-4 py-24 text-gray-400">
      <BarChart3 size={32} />
      <div>
        <p className="text-lg font-medium text-gray-600">Monitoring</p>
        <p className="text-sm">Sera implémenté ultérieurement</p>
      </div>
    </div>
  );
}
